import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { getUsers, createMatch } from '../api';

function Swipe() {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [current, setCurrent] = useState(0);
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [matchAlert, setMatchAlert] = useState(null);
  const [cardStyle, setCardStyle] = useState({});
  const [swiping, setSwiping] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getUsers();
        setProfiles(response.data);
      } catch (err) {
        console.error('Error fetching users:', err);
      }
      setLoading(false);
    };
    fetchUsers();
  }, []);

  const swipeCard = async (direction, profile) => {
    if (swiping) return;
    setSwiping(true);

    // Animate card out
    setCardStyle({
      transform: direction === 'right'
        ? 'translateX(150px) rotate(15deg)'
        : 'translateX(-150px) rotate(-15deg)',
      opacity: 0,
      transition: 'transform 0.5s ease, opacity 0.5s ease'
    });

    // Wait for animation then move to next card
    setTimeout(() => {
      setCardStyle({});
      setCurrent(prev => prev + 1);
      setSwiping(false);
    }, 550);
  };

  const handleLike = async () => {
  if (swiping) return;
  const profile = profiles[current];
  
  // Swipe animation first - no matter what
  swipeCard('right', profile);

  // API call separately - won't block animation
  try {
    await createMatch(profile.id);
    const isMatch = Math.random() > 0.5;
    if (isMatch) {
      setMatches(prev => [...prev, profile]);
      setMatchAlert(profile);
      setTimeout(() => setMatchAlert(null), 3000);
    }
  } catch (err) {
    // Match already exists - that's okay, just keep swiping
    console.log('Match already exists or error:', err.message);
  }
};

  const handlePass = () => {
    const profile = profiles[current];
    swipeCard('left', profile);
  };

  if (loading) {
    return (
      <div className="container">
        <div className="hero">
          <p className="auth-eyebrow">✦ Kami Cupid</p>
          <h1 className="auth-title">Finding<br />Matches</h1>
          <p className="auth-divider">— ✦ —</p>
          <p className="tagline">Please wait a moment...</p>
        </div>
      </div>
    );
  }

  if (profiles.length === 0 || current >= profiles.length) {
    return (
      <div className="container">
        <div className="hero">
          <p className="auth-eyebrow">✦ Kami Cupid</p>
          <h1 className="auth-title">All Done<br />For Now</h1>
          <p className="auth-divider">— ✦ —</p>
          <p className="tagline">You have {matches.length} match(es) 💕</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '20px' }}>
            <button className="btn-signup" onClick={() => navigate('/matches')}>
              View Matches
            </button>
            <button className="btn-login" onClick={() => navigate('/profile')}>
              Edit Profile
            </button>
          </div>
        </div>
      </div>
    );
  }

  const profile = profiles[current];

  return (
    <div className="swipe-page">
      {matchAlert && (
        <div className="match-alert">
          <p className="match-alert-text">💘 It's a Match!</p>
          <p className="match-alert-name">You and {matchAlert.name} liked each other</p>
        </div>
      )}

      <div className="swipe-header">
  <p className="auth-eyebrow" style={{ margin: 0 }}>✦ Kami Cupid</p>
  <div className="swipe-header-actions">
    <span className="nav-link" onClick={() => navigate('/matches')}>
      Matches {matches.length > 0 && <span className="match-badge">{matches.length}</span>}
    </span>
    <span className="nav-link" onClick={() => navigate('/profile')}>Profile</span>
    <span className="nav-link" style={{ color: '#c9607a' }} onClick={() => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      navigate('/');
    }}>Logout</span>
  </div>
</div>

      <div className="swipe-card" style={cardStyle}>
        <div className="card-photo-large">
          {profile.photo ? (
            <img src={profile.photo} alt={profile.name} className="card-photo-img" />
          ) : (
            <span className="card-avatar">👤</span>
          )}
          <div className="card-gradient-overlay">
  <h2 className="card-name">{profile.name}, {profile.age}</h2>
  {profile.distance !== null && profile.distance !== undefined && (
    <p className="card-bio">📍 {profile.distance} km away</p>
  )}
  <p className="card-bio">{profile.bio}</p>
  {profile.interests && (
    <p className="card-interests">✦ {profile.interests}</p>
            )}
          </div>
        </div>
      </div>

      <div className="swipe-buttons">
        <button className="btn-pass" onClick={handlePass} disabled={swiping}>✕</button>
        <button className="btn-like" onClick={handleLike} disabled={swiping}>💘</button>
      </div>

      <p className="swipe-counter">
        {current + 1} of {profiles.length} profiles
      </p>
    </div>
  );
}

export default Swipe;